export default __webpack_public_path__ + "static/media/preview-video-3.b5aedfeb.jpeg";